import { AppLanguageMenu } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { Locale } from "@tfg/types/schemas/enum"

import { SUPPLIER_LOCALES } from "~/i18n"
import { findLanguage, findLanguageFlag } from "~/utils/languages.tsx"

export const SupplierAppLanguageMenu = () => {
  const { i18n } = useTranslation()

  return (
    <AppLanguageMenu
      currentLocale={findLanguage(i18n.language.toUpperCase())}
      handleLanguageChange={async (locale) => {
        await i18n.changeLanguage(locale)
      }}
      languageItems={SUPPLIER_LOCALES.map((locale) => ({
        label: findLanguage(locale.toUpperCase()),
        value: locale,
        icon: findLanguageFlag(locale.toUpperCase() as Locale),
      }))}
    />
  )
}
